import XLSX from "xlsx-js-style";

export const formatDateForFilename = (dateStr) => {
  var month = parseInt(dateStr.slice(0, 2)) - 1;
  var year = parseInt(dateStr.slice(3));
  var dateObj = new Date(year, month, 1);

  var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return `${
    monthNames[dateObj.getMonth()]
  } ${dateObj.getDate()}, ${dateObj.getFullYear()}`;
};

export const formatEndDateForFilename = (dateStr) => {
  var month = parseInt(dateStr.slice(0, 2)) - 1;
  var year = parseInt(dateStr.slice(3));
  var dateObj = new Date(year, month + 1, 0);

  var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return `${
    monthNames[dateObj.getMonth()]
  } ${dateObj.getDate()}, ${dateObj.getFullYear()}`;
};

export const generateExcelFile = (data, options = {}) => {
  const { header, body } = data;

  if (!header || !body || body.length === 0) {
    throw new Error("No data available to export.");
  }

  // Sort data by Month/Year if those columns exist
  const monthYearIndex = header.findIndex((col) => col === "Month/Year");
  if (monthYearIndex !== -1) {
    body.sort((a, b) => {
      const aValues = a[monthYearIndex].split("/");
      const bValues = b[monthYearIndex].split("/");

      const aYear = parseInt(aValues[1]);
      const bYear = parseInt(bValues[1]);

      if (aYear !== bYear) {
        return aYear - bYear;
      }

      const aMonth = parseInt(aValues[0]);
      const bMonth = parseInt(bValues[0]);
      return aMonth - bMonth;
    });
  }

  // Calculate Totals
  const totals = [];
  const numericColumns = {};
  header.forEach((title, index) => {
    totals[index] = "";
    if (
      [
        "Total page views",
        "Paid page views",
        "Free page views",
        "Sessions",
        "Turnaways",
      ].includes(title)
    ) {
      numericColumns[index] = 0;
    }
  });

  body.forEach((row) => {
    Object.keys(numericColumns).forEach((indexStr) => {
      const index = parseInt(indexStr);
      let cellData = row[index];
      let numericVal = 0;
      if (typeof cellData === "string") {
        numericVal = parseFloat(cellData.replace(/[^0-9.-]+/g, ""));
      } else if (typeof cellData === "number") {
        numericVal = cellData;
      }
      numericColumns[index] += isNaN(numericVal) ? 0 : numericVal;
    });
  });

  totals[0] = "Total";
  Object.keys(numericColumns).forEach((indexStr) => {
    const index = parseInt(indexStr);
    totals[index] = numericColumns[index];
  });

  // Create worksheet with styling
  const ws = XLSX.utils.aoa_to_sheet([header, ...body, totals]);

  // Apply styles
  const headerStyle = {
    font: { bold: true },
    alignment: { horizontal: "center" },
  };

  const totalsStyle = {
    font: { bold: true },
    alignment: { horizontal: "center" },
  };

  // Style header row
  const range = XLSX.utils.decode_range(ws["!ref"]);
  for (let C = range.s.c; C <= range.e.c; C++) {
    const headerCell = XLSX.utils.encode_cell({ r: 0, c: C });
    ws[headerCell].s = headerStyle;
  }

  // Style totals row
  const lastRow = range.e.r;
  for (let C = range.s.c; C <= range.e.c; C++) {
    const totalsCell = XLSX.utils.encode_cell({ r: lastRow, c: C });
    ws[totalsCell].s = totalsStyle;
  }

  // Create workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Usage Data");

  // Auto-fit column widths based on content
  const maxWidths = {};

  // Get max width for each column including header
  data.header.forEach((header, colIndex) => {
    maxWidths[colIndex] = String(header).length;
  });

  // Check content width for each column
  data.body.forEach((row) => {
    // Handle both array and object data formats from DataTables
    const rowData = Array.isArray(row) ? row : Object.values(row);
    rowData.forEach((cell, colIndex) => {
      const cellLength = String(cell || "").length;
      maxWidths[colIndex] = Math.max(maxWidths[colIndex], cellLength);
    });
  });

  // Set column widths in worksheet with minimum width
  ws["!cols"] = Object.values(maxWidths).map((width) => ({
    wch: Math.max(width + 2, 8), // Add padding and ensure minimum width of 8
  }));

  // Generate filename
  let filename = "UsageReport.xlsx";
  if (
    options.startDate &&
    options.endDate &&
    options.partyName &&
    options.partnerName
  ) {
    const formattedStartDate = formatDateForFilename(options.startDate);
    const formattedEndDate = formatEndDateForFilename(options.endDate);
    filename = `${
      options.partyName
    } - ${options.partnerName.toUpperCase()} Usage - ${formattedStartDate} to ${formattedEndDate}.xlsx`;
  }

  return { workbook: wb, filename };
};

export const convertToCSV = (data) => {
  let csvContent =
    "IP Address,Total page views,Paid page views,Free page views,Sessions,Turnaways,Party Name,Partner,Year/Month,\r\n";
  data.body.forEach(function (rowArray) {
    const row = rowArray
      .map(function (cell) {
        return String(cell).replace(/,/g, ";");
      })
      .join(",");
    csvContent += row + "\r\n";
  });
  return csvContent;
};



// WEBPACK FOOTER //
// ./src/utils/exportUtils.js